wbApp.controller('OnlinePaymentsCtrl', ['$scope', '$modal', '$q', '$translate', '$filter', '$window',
    'onlinePaymentsSvc', 'securitySvc', 'messageBoxSvc', 'gridSortSvc',
function ($scope, $modal, $q, $translate, $filter, $window,
    onlinePaymentsSvc, securitySvc, messageBoxSvc, gridSortSvc) {

    $scope.gridSettings = {
        columns: [
            {
                dataField: 'studentFullName', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string', width: '160px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'studentFullName') }
            },
            {
                dataField: 'parentFullName', caption: $translate.instant("TXT_LBL_PARENT"), dataType: 'string', width: '160px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'operatorFullName') }
            },
            { dataField: 'productName', caption: $translate.instant('TXT_LBL_TYPE'), dataType: 'string', width: '55px' },
            { dataField: 'description', caption: $translate.instant('TXT_LBL_SUBJECT'), dataType: 'string' },
            {
                dataField: 'state',
                caption: $translate.instant('TXT_LBL_STATE'),
                dataType: 'number',
                width: '80px',
                lookup: {
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: 0, name: $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_NONE') },
                                { id: 1, name: $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_CREATED') },
                                { id: 2, name: $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_PENDING') },
                                { id: 3, name: $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_PAID') },
                                { id: 4, name: $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_REVERSED') },
                                { id: 5, name: $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_AUTOREVERSED') },
                                { id: 6, name: $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_CANCELLED') },
                                { id: 7, name: $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_DECLAINED') },
                                { id: 8, name: $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_ERROR') },
                                { id: 9, name: $translate.instant('TXT_VAL_ONLINE_PAYMENT_STATUS_MANUALLY_REVERSED') }
                            ],
                            key: "id"
                        }
                    },
                    valueExpr: 'id', 
                    displayExpr: 'name'
                }
            },
            { dataField: 'price', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            {
                dataField: 'createdAt',
                caption: $translate.instant('TXT_LBL_DATE'),
                sortOrder: 'desc',
                dataType: 'date',
                format: 'shortDateShortTime',
                width: '130px'
            },
            { dataField: 'isTesting', caption: $translate.instant('TXT_LBL_IS_TESTING'), dataType: 'boolean', width: '80px' },
        ],
        shouldDisableDelete: function(row) { return !row.isTesting && row.state === 3 /* Paid */; },
        customCommands: [{
                text: $translate.instant('TXT_MENU_PRINT_INVOICE'),
                isVisible: function (row) { 
                    return !!row.invoiceID && securitySvc.isInRole('CourseRegistration.PrintInvoice') && securitySvc.isInRole('Reports'); 
                    },
                callback: function (row) { onPrintInvoice(row.invoiceID); }
        }, {
            text: $translate.instant('TXT_LBL_REVERSE_PAYMENT'),
            isVisible: function (row) {
                return securitySvc.isInRole('OnlinePayment.Update') &&
                    moment(row.createdAt).isAfter(moment().subtract(90, 'days')) &&
                    row.state === 3 &&                    
                    row.providerType === 0; // Payeezy
            },
            callback: function (row) { onReverseOnlinePayment(row.onlinePaymentID); }
        }, {
            text: $translate.instant('TXT_LBL_MANUALLY_REVERSE_PAYMENT_DELETE_PAYMENTS'),
            isVisible: function (row) {
                return securitySvc.isInRole('OnlinePayment.Update') &&
                    moment(row.createdAt).isBefore(moment().subtract(2, 'hour')) &&
                    (row.state === 2 || row.state === 3); // Pending || Paid
            },
            callback: function (row) { onManuallyReverseOnlinePayment(row.onlinePaymentID); }
        }, {
            text: $translate.instant('TXT_MENU_CREATE_PAYMENT'),
            isVisible: function (row) {
                return securitySvc.isInRole('OnlinePayment.Update') &&
                    !row.invoiceID && 
                    (row.state === 9); // ManuallyReversed
            },
            callback: function (row) { addPayment(row); }
        }, ]
    }

    function onPrintInvoice(invoiceID) {
        $window.open('/Admin/Report/Invoice?ReportID=' + invoiceID + '&ReportIDType=1',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    function onReverseOnlinePayment(onlinePaymentID) {

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_REVERSE',
            message: 'TXT_TEXT_CONFIRM_REVERSE',
            buttons: [{
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: function () {
                    onlinePaymentsSvc.reverse(onlinePaymentID);
                }
            }]
        });
    }

    function onManuallyReverseOnlinePayment(onlinePaymentID) {

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_MANUAL_REVERSE',
            message: 'TXT_TEXT_CONFIRM_MANUAL_REVERSE_DELETE_PAYMENTS',
            buttons: [{
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: function () {
                    onlinePaymentsSvc.manualReverse(onlinePaymentID);
                }
            }]
        });
    }    

    $scope.fromDate = moment().startOf('month').toDate();
    $scope.toDate = moment().endOf('month').toDate();

    $scope.$on('refreshData', function (e, data) {
        refreshData($scope.fromDate, $scope.toDate, true);
    });

    function refreshData(fromDate, toDate, refresh) {
        $scope.onlinePayments = onlinePaymentsSvc.getAllByDateRange(fromDate, toDate, refresh);
    }

    refreshData($scope.fromDate, $scope.toDate, false);

    $scope.onFromDateChange = function (fromDate) {
        if (fromDate) {
            refreshData(fromDate, $scope.toDate);
        }
    }

    $scope.onToDateChange = function (toDate) {
        if (toDate) {
            refreshData($scope.fromDate, toDate);
        }
    }

    $scope.onRowSelected = function (data) {
        $scope.selectedOnlinePayment = data;        
    }

    $scope.onRowEdit = function (data) {
    }

    $scope.onRowDelete = function (data) {
        onlinePaymentsSvc.remove(data);
    }

    var addPaymentPromise = $modal({
        templateUrl: 'finance/payments/payments-detail.html',
        show: false,
        scope: $scope.$new()
    });

    function addPayment(data) {
        
        // var parsingRegExp = new RegExp(".*\[(.*)\s-\s(.*)\s-\s(.*)]", "g");
        // var match = parsingRegExp.exec(data.description);
        
        addPaymentPromise.$scope.isOnlinePayment = true;
        addPaymentPromise.$scope.onlineTransactionDetail = {
            text: data.description,
            transactionID: data.onlinePaymentID
        };
        addPaymentPromise.$scope.paymentDetail = {
            paymentID: 0,
            paymentTypeID: 4,
            amount: data.price,
            selectedDate: data.createdAt,
        };

        addPaymentPromise.$promise.then(function () {
            addPaymentPromise.$scope.detailError = null;
            addPaymentPromise.$scope.onSave = function () {
                refreshData($scope.fromDate, $scope.toDate, true);
            }

            addPaymentPromise.show();
        });
    }    
    
    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "finance/online-payments/online-payments-tabs/detail.html"
    }];
}]);
